/** Create a new object with @see propertiesToKeep off from @see item. */
export function pick<
  T extends object,
  K extends keyof(T)
>(
  item: T,
  propertiesToKeep: K[]
): Pick<T, K> {
  const fieldSet = new Set(propertiesToKeep);

  return Object.fromEntries(
    Object.entries(item).filter(([key]) => {
      return fieldSet.has(key as K);
    })
  ) as Pick<T, K>;
}
